import {Button, Flex, IconButton, Text, useMultiStyleConfig} from '@chakra-ui/react'
import React, {useEffect, useState} from 'react'
import CloseIcon from '../icons/action/CloseIcon'
import Cookies from 'js-cookie'
import {FormattedMessage} from 'react-intl'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {useGetCountrySelector} from '../../custom-api/hooks/use-get-country-selector'
import useCountries from '../../hooks/use-countries'
import {handleLocale} from '../../utils/locale'

const CountrySelectorBanner = () => {
    const style = useMultiStyleConfig('CountrySelector')
    const {locale, buildUrl} = useMultiSite()
    const [isVisible, setIsVisible] = useState(false)
    const localeAlias = locale?.alias || null

    const {data} = useGetCountrySelector()
    const countries = useCountries(data)

    const [cdnValue, setCdnValue] = useState()

    useEffect(() => {
        const countrySelectorCookie = Cookies.get('cdn-country')
        setCdnValue(countrySelectorCookie)
        const dlgCountrySelectorCookie = Cookies.get('dlg-country')
        const dlgMatchesIpCookie = dlgCountrySelectorCookie === countrySelectorCookie
        if (localeAlias) {
            if (countrySelectorCookie && countrySelectorCookie !== localeAlias) {
                //rules R9 R10 R11 R12
                setIsVisible(true)
                if (!dlgCountrySelectorCookie || dlgCountrySelectorCookie !== localeAlias) {
                    Cookies.set('dlg-country', localeAlias, {expires: 30})
                }
            } else if (
                //rulse R6 and R8
                (!countrySelectorCookie && !dlgCountrySelectorCookie) ||
                (localeAlias === countrySelectorCookie && dlgMatchesIpCookie)
            ) {
                setIsVisible(false)
            } else if (
                //rules R7 and R8b
                localeAlias === countrySelectorCookie &&
                !dlgMatchesIpCookie
            ) {
                Cookies.set('dlg-country', localeAlias, {expires: 30})
            }
        }
    }, [])

    const match =
        countries && cdnValue
            ? countries
                  .flatMap((region) => Object.values(region.countries).flat())
                  .find((c) => c.url.toLowerCase() === `/${cdnValue.toLowerCase()}`)
            : {}

    const handleDismiss = () => {
        Cookies.set('dlg-country', localeAlias, {expires: 30})
        setIsVisible(false)
    }

    if (!isVisible) {
        return null
    }

    return (
        <Flex {...style.container}>
            <Flex {...style.content}>
                <IconButton
                    icon={<CloseIcon {...style.closeIcon} />}
                    {...style.buttonIcon}
                    {...style.hideOnDesktop}
                    onClick={handleDismiss}
                />
                <Text {...style.label}>
                    <FormattedMessage
                        id="country_selector.label_choose_country"
                        defaultMessage="Choose your preferred country to view local content and get a better experience."
                    />
                </Text>
                <Flex {...style.ctaContainer}>
                    <Button
                        as="a"
                        href="#"
                        data-testid="go-to-country-button"
                        onClick={(event) => handleLocale(event, match, buildUrl, cdnValue)}
                        {...style.blueButton}
                    >
                        <Text {...style.blueButtonText}>
                            <FormattedMessage
                                id="country_selector.button_go_to_country"
                                defaultMessage="Go to {country}"
                                values={{country: match?.country || 'your country'}}
                            />
                        </Text>
                    </Button>
                    <Button {...style.whiteButton} onClick={handleDismiss}>
                        <Text {...style.whiteButtonText}>
                            <FormattedMessage
                                id="country_selector.button_select_another_country"
                                defaultMessage="Select another country"
                            />
                        </Text>
                    </Button>
                </Flex>
                <IconButton
                    icon={<CloseIcon {...style.closeIcon} />}
                    {...style.buttonIcon}
                    {...style.hideOnMobile}
                    onClick={handleDismiss}
                />
            </Flex>
        </Flex>
    )
}

export default CountrySelectorBanner
